module.exports = __webpack_public_path__ + "img/profile-wbg.7a465725.png";